'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

const AlexIdQuestionComponent = () => {
  const router = useRouter();

  useEffect(() => {
    // This is only used in caq now with auth gate
    // so we can force a user to pi
    router.push(`/auth/login?returnTo=/pi&screen_hint=signup`);
  }, [router]);

  return null;
};

export default AlexIdQuestionComponent;
